(function() {
    // 注册组件
    SR.modules.extend('answer.repeat', repeat);

    function repeat(askId, askOptions) {
        var askOptions = askOptions || {};
        var $ask = $('#' + askId);
        var ask = $ask.text();
        var isLoadHistory = askOptions.isLoadHistory ? 'true' : 'false';
        $ask.find('.content').empty().append('<a href="#;" class="J_ask repeat" data-option=\'{"inputType": 0}\' data-askid="' + askId + '" data-loadhistory="' + isLoadHistory + '">' + ask + '</a>');
    }
})();
